<div class="sp-offcanvas-panel__body sp-scroll ps ps--active-y" style="height: 555px; overflow: hidden;">
    <div class="subtitle mb-4 mt-3">Tarjetas</div>
    <div class="sp-grid-nav-v2 mx-4">
        <a class="sp-grid-nav-v2__item mr-2" routerLink="/pageTabPanel"  (click)="getDataMicroApp(idDesinger)">
            <div class="sp-grid-nav-v2__item-icon">
                <i class="fa-solid fa-laptop-code"></i>
            </div>
            <div class="sp-grid-nav-v2__item-title">Diseñador Formularios Dinamicos</div>
        </a>
        <a class="sp-grid-nav-v2__item"routerLink="/pageTabPanel" (click)="getDatareporting()">
            <div class="sp-grid-nav-v2__item-icon">
                <i class="fa-solid fa-line-chart"></i>
            </div>
            <div class="sp-grid-nav-v2__item-title">Reporteador</div>
        </a>
    </div>


    <div class="sp-grid-nav-v2 mx-4">
        <a class="sp-grid-nav-v2__item mr-2"  [routerLink]="['/CompanySettingsList']" (click)="closeEmit()">
            <div class="sp-grid-nav-v2__item-icon">
                <i class="fa-solid fa-paint-brush"></i>
            </div>
            <div class="sp-grid-nav-v2__item-title">Temas</div>
        </a>
        <a class="sp-grid-nav-v2__item" [routerLink]="canNavigate ? ['/microapplication-list'] : null" (click)="onItemClick($event)">
            <div class="sp-grid-nav-v2__item-icon">
                <i class="fa-solid fa-building-shield"></i>
            </div>
            <div class="sp-grid-nav-v2__item-title">Microaplicaciones</div>
        </a>

 
    </div>

    <div class="sp-grid-nav-v2 mx-4">
        <a class="sp-grid-nav-v2__item"routerLink="/pageTabPanel" (click)="getDataoctober()">
            <div class="sp-grid-nav-v2__item-icon">
                <i class="fa-solid fa-folder-open"></i>
            </div>
            <div class="sp-grid-nav-v2__item-title">Ayuda en linea</div>
        </a>
        <a class="sp-grid-nav-v2__item"routerLink="/pageTabPanel" (click)="getDataalertpanel()">
            <div class="sp-grid-nav-v2__item-icon">
                <i class="fa-solid fa fa-exclamation-circle"></i>
            </div>
            <div class="sp-grid-nav-v2__item-title">Alertas</div>
        </a>
        <a class="sp-grid-nav-v2__item" [routerLink]="['/widgetvisualizercomponent']"  >
            <div class="sp-grid-nav-v2__item-icon">
                <i class="fa-solid fa-bar-chart"></i>
            </div>
            <div class="sp-grid-nav-v2__item-title">Widget</div>
        </a>
        <a class="sp-grid-nav-v2__item" [routerLink]="['/miPerfil']"  (click)="closeEmit()">
            <div class="sp-grid-nav-v2__item-icon">
                <i class="fa-solid fa-address-card"></i>
            </div>
            <div class="sp-grid-nav-v2__item-title">Mi perfil</div>
        </a>
    </div>

 

    <div class="sp-grid-nav-v2 mx-4">

        <a class="sp-grid-nav-v2__item"routerLink="/pageTabPanel"   (click)="getDataagend()">
            <div class="sp-grid-nav-v2__item-icon">
                <i class="fa-solid fa-calendar"></i>
            </div>
            <div class="sp-grid-nav-v2__item-title">Agenda</div>
        </a>
     
    </div>

    

    <div class="sp-grid-nav-v2 mx-4">

    </div>

    <!-- <div class="subtitle mb-4 mt-3">Favoritos</div>
    <div #favoriteBody id="sp_offcanvas_toolbar_quick_favorites">  
        <div class="quickAccessPanelContent">
            <div class="sp-grid-nav-v2">
                <div class="flex-row-fluid ">
                    <div class="row">
                        <div *ngFor="let forma of favoriteListArr" class="col-12 pr-0">
                            <div class="sp-portlet">
                                <a class="sp-menu__link" routerLink="/pageTabPanel">
                                    <div class="sp-portlet__body">
                                        <div class="kt-header__topbar-item">
                                            <div class="kt-header__topbar-wrapper row mr-2">
                                                <div class="row col" (click)="generarPage(forma)">
                                                    <span class="kt-header__topbar-icon kt-bg-brand btn-principal col-2">
                                                        <i class="la la-coins kt-font-light"></i>
                                                    </span>
                                                    <span class="sp-portlet__head-title col align-self-sm-center">
                                                        {{forma.nom_prog}}
                                                    </span>
                                                </div>
                                                <button type="button" aria-label="Close" class="close modal-close classHover col-2" style=" font-size: 1.8rem;" (click)="deleteFavorite($event, forma)" data-toggle="tooltip" data-placement="auto" title="Quitar favorito">
                                                    <i class="fa-solid fa-xmark"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</div>